import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

export default function AutoLogin({ children }) {
  const token = Cookies.get("token");

  if (token) {
    return <Navigate to="/CleanSlate" replace />;
  }

  return children;
}
